import { useDispatch } from "react-redux";
import { startAlerta } from "../actions/ui/alertas";

export const useValidationForm = () => {
    const dispatch = useDispatch();

    const validationForm = (validations = []) => {
        try {
          validations.forEach(validation => {
            if (validation.errorCondition) {
              throw new Error(validation.errorMessage);
            }
          });
      
          return true;
        } catch (error) {
          dispatch(startAlerta(error.message, 'error'));
          return false;
        }
    }

    return validationForm;
};

